import React from 'react';
import Modal from "react-modal";
import modalStyle from "app/data/common/modalStyle"
import { ReactComponent as AlertIcon } from "images/alert.svg";
import { ReactComponent as CrossGrayIcon } from "images/cross_gray.svg";
import Button, { ButtonThemes } from 'ui-components/button/button';
import { useDispatch, useSelector } from 'react-redux';
import { getTerminalSummaryByTerminalNumber, terminalDetailsSelector } from 'slices/terminal-summary/terminalDetailsSlice';
import { UpdateStatus } from 'app/data/terminal-details/models';
import TerminalService from 'app/data/terminal-details/terminalService';
import { toast } from 'react-toastify';
import { ERROR_MESSAGES } from 'app/data/common/errorMessages';
import { useMutation } from '@tanstack/react-query';
import { TerminalState } from 'slices/terminal-summary/TerminalDetailsState';

const EditStatus = ({
  showModal,
  handleClose,
}: {
  showModal: boolean,
  handleClose: () => void,
}): React.ReactElement => {

  const dispatch = useDispatch();
  const terminalService = TerminalService.getInstance();
  const terminalState: TerminalState = useSelector(terminalDetailsSelector);

  const updateTerminalStatusMutation = useMutation({
    mutationFn: ({ terminalNumber, data }: { terminalNumber: string, data: UpdateStatus }) => {
      return terminalService.updateTerminalStatus(terminalNumber, data)
    },
    onSuccess: () => {
      toast.info("Terminal status updated successfully");
      if (terminalState.data?.terminalNumber) {
        dispatch(getTerminalSummaryByTerminalNumber(terminalState.data?.terminalNumber.toString()));
      }
      handleClose();
    },
    onError: (e: any) => {
      if (e instanceof Error) {
        toast.error(e.message);
      }
      else if (e?.response?.data?.message) {
        toast.error(e.response.data.message);
      }
      else {
        toast.error(ERROR_MESSAGES.COMMON);
      }
    },
  });

  return (
    <Modal
      isOpen={showModal}
      style={{
        ...modalStyle, content: {
          ...modalStyle.content,
          width: "400px",
          maxWidth: "90vw",
          minWidth: "300px",
        }
      }}
      onRequestClose={() => { }}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <div className="update-terminal">
        <div className="update-terminal__close">
          <CrossGrayIcon onClick={() => handleClose()} />
        </div>
        <div className="update-terminal__container">
          <AlertIcon />
          <div className="update-terminal__inactive">
            Are you sure you want to mark this terminal as {terminalState.data?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"}?</div>
        </div>
        <div className="update-terminal__form__content__edit__button">
          <Button
            theme={ButtonThemes.gray}
            type="button"
            onClick={() => {
              if (terminalState.data?.terminalNumber) {
                updateTerminalStatusMutation.mutate({
                  terminalNumber: terminalState.data?.terminalNumber.toString(),
                  data: { status: terminalState.data?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE" }
                });
              }
            }}
            spinner={updateTerminalStatusMutation.isLoading}
            className="update-terminal__form__content__edit__button__cancel"
          >
            Yes
          </Button>
          <Button
            theme={ButtonThemes.blue}
            type="submit"
            spinner={updateTerminalStatusMutation.isLoading}
            className="update-terminal__form__content__edit__button__submit"
            onClick={() => {
              handleClose();
            }}
          >
            No
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditStatus;
